import React, { useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import queryString from 'query-string'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { authenticateUser } from '@/reducers/auth/currentUser.actions'
import { clearAuthMessage } from '@/reducers/ui/ui.redux'
import { resetMFA } from '@/reducers/auth/mfa.redux'
import { safeNextPath, withNext } from '@/reducers/auth/loginNext.helpers'
import { AuthContainer } from './AuthContainer'
import { AuthMessage } from './AuthMessage'

const LoginPageComponent = ({ ldClient }) => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { next } = queryString.parse(location.search)

  const handleLogin = ({ email, password }, { setSubmitting }) => {
    dispatch(authenticateUser({ email, password, history, location, ldClient }, setSubmitting))
  }

  useEffect(() => {
    // MFA redirects back to this page on both success/failure, clear its state when it does so
    dispatch(resetMFA())

    // if we receive search params here it's because it's a login attempt through SSO
    // it needs to have everything that a standard login has
    const { search } = location
    const { token, keepError } = queryString.parse(search)

    if (!keepError) {
      dispatch(clearAuthMessage())
    }

    if (token) {
      dispatch(authenticateUser({ token, history, location, ldClient }))
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Login | Balto Cloud</title>
      </Helmet>

      <AuthContainer>
        <h2 data-testid="login-page">Login</h2>
        <AbstractForm
          schema={[
            { name: 'email', type: 'text', label: 'Email', required: true },
            {
              name: 'password',
              type: 'password',
              inputType: 'password',
              label: 'Password',
              required: true,
            },
          ]}
          onSubmit={handleLogin}
          buttonProps={{ fullWidth: true }}
          buttonLabel="Login"
        />
        <AuthMessage />
        <Link to="/reset_password" className="link">
          Forgot your password?
        </Link>
        <br />
        <Link to={withNext('/login_sso', safeNextPath(next))} className="link">
          Login using SSO
        </Link>
      </AuthContainer>
    </>
  )
}

export default withLDConsumer()(LoginPageComponent)
